import React, { FC, ReactElement } from 'react';
import {Button, Result} from "antd";
import {usePreserveQueryNavigate} from "../components/PreserveQueryLink";

interface Props {
    error: unknown;
    componentStack: string | null;
    eventId: string | null;
    resetError(): void;
}

export const ServerErrorPage: FC<Props> = ({resetError}): ReactElement => {
    const navigate = usePreserveQueryNavigate();

    return (
        <Result
            status="500"
            title="500"
            subTitle="Sorry, something went wrong."
            extra={<Button type="primary" onClick={() => {
                navigate('/');
                resetError();
            }}>Back Home</Button>}
        />
    );
};
